var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 16,
    fill: "#E0F0E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 64,
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 20,
    width: 36,
    height: 36,
    rx: 6,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 67,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#61B369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3758 79.2459C86.8292 79.2459 88 78.0757 88 76.623C88 75.1703 86.8292 74 85.3758 74C83.9224 74 82.7515 75.1702 82.7515 76.623C82.7515 77.0467 82.8525 77.4704 83.0543 77.8133L79.3602 80.174C78.896 79.7705 78.2904 79.5081 77.6242 79.5081C76.1708 79.5081 75 80.6784 75 82.1311C75 83.5838 76.1708 84.7541 77.6242 84.7541C78.2904 84.7541 78.896 84.4917 79.3602 84.0883L82.9332 86.3884C82.8121 86.6909 82.7313 87.0341 82.7313 87.377C82.7313 88.8297 83.9021 90 85.3555 90C86.8089 90 87.9797 88.8298 87.9797 87.377C87.9797 85.9243 86.8089 84.7541 85.3555 84.7541C84.6894 84.7541 84.104 84.9961 83.6396 85.3998L80.0666 83.0995C80.1877 82.797 80.2483 82.4741 80.2483 82.1311C80.2483 81.7881 80.1877 81.4653 80.0666 81.1627L83.8414 78.7416C84.2654 79.0643 84.7903 79.246 85.3757 79.246L85.3758 79.2459Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30.3232C72 29.6498 72.2252 29.0943 72.6757 28.6566C73.1261 28.2188 73.7117 28 74.4324 28C75.1403 28 75.713 28.2155 76.1506 28.6465C76.601 29.0909 76.8263 29.67 76.8263 30.3838C76.8263 31.0303 76.6075 31.569 76.1699 32C75.7194 32.4444 75.1274 32.6667 74.3938 32.6667H74.3745C73.6667 32.6667 73.094 32.4444 72.6564 32C72.2188 31.5556 72 30.9966 72 30.3232ZM72.251 48V34.5051H76.5367V48H72.251ZM78.9112 48H83.1969V40.4646C83.1969 39.9933 83.2484 39.6296 83.3514 39.3737C83.5315 38.9158 83.805 38.5286 84.1718 38.2121C84.5386 37.8956 84.9987 37.7374 85.5521 37.7374C86.9936 37.7374 87.7143 38.7542 87.7143 40.7879V48H92V40.2626C92 38.2694 91.5496 36.7576 90.6486 35.7273C89.7477 34.697 88.5573 34.1818 87.0772 34.1818C85.417 34.1818 84.1236 34.9293 83.1969 36.4242V36.4646H83.1776L83.1969 36.4242V34.5051H78.9112C78.9369 34.936 78.9498 36.2761 78.9498 38.5253C78.9498 40.7744 78.9369 43.9326 78.9112 48Z",
    fill: "#AEDACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 45C48 47 47 48 45 48H31C29 48 28 47 28 45V31C28 29 29 28 31 28H45C47 28 48 29 48 31V45ZM41.7989 40.254V47.9994H38.6867V40.254H36.0791V37.235H38.6867V35.0076C38.6867 32.4232 40.2622 31.0185 42.5672 31.0185C43.6693 31.0185 44.6161 31.0961 44.8955 31.1349V33.8435H43.2968C42.0395 33.8435 41.7989 34.4333 41.7989 35.3103V37.235H44.7869L44.3988 40.254H41.7989Z",
    fill: "#AEDACA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9188 91C42.221 91 46.7613 84.0756 46.7613 78.071C46.7613 77.8743 46.7573 77.6786 46.7485 77.4836C47.6319 76.8401 48.3943 76.0433 49 75.1306C48.1912 75.4926 47.3209 75.7362 46.4079 75.846C47.3398 75.2835 48.0553 74.3935 48.3928 73.3327C47.5068 73.8618 46.5374 74.2349 45.5266 74.4357C44.703 73.5524 43.5304 73 42.2319 73C39.7393 73 37.718 75.035 37.718 77.5434C37.718 77.9001 37.7576 78.2468 37.8351 78.5796C34.0837 78.3895 30.7572 76.5813 28.531 73.8319C28.13 74.5253 27.9191 75.3135 27.9198 76.1158C27.9198 77.6923 28.7166 79.084 29.9284 79.8983C29.2116 79.8762 28.5106 79.6813 27.8842 79.3299C27.8835 79.349 27.8835 79.3676 27.8835 79.388C27.8835 81.5886 29.4394 83.426 31.5047 83.8423C31.1168 83.9487 30.7165 84.0025 30.3145 84.0022C30.0242 84.0022 29.7412 83.9735 29.4662 83.9203C30.0408 85.7258 31.7071 87.0397 33.6827 87.0764C32.1378 88.2954 30.1917 89.0215 28.0767 89.0215C27.7169 89.0218 27.3573 89.0008 27 88.9585C28.9976 90.2476 31.3696 90.9997 33.919 90.9997",
    fill: "#AEDACA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareVideoIcon);
export default __webpack_public_path__ + "static/media/shareVideoIcon.84a40c5d.svg";
export { ForwardRef as ReactComponent };